import React from 'react';
import { FiltersProvider } from "../../../../../components/providers/FiltersProvider";
import UserCalls from "./UserCalls";
import UserProfileLayout from "../../UserProfileLayout";

interface UserCallsListWrapperProps { }

const UserCallsListWrapper: React.FC<UserCallsListWrapperProps> = () => {

    return (
        <FiltersProvider>
            <UserProfileLayout>
                <UserCalls />
            </UserProfileLayout>
        </FiltersProvider>
    );
}

export default UserCallsListWrapper;